@if (rondleiding.stap(); as stap) {
  @if (spot(); as s) {
    <div class="spot"
         [class.zichtbaar]="zichtbaar()"
         [style.top.px]="s.top"
         [style.left.px]="s.left"
         [style.width.px]="s.width"
         [style.height.px]="s.height"></div>
  }

  <div #ballon
       class="ballon"
       role="dialog"
       aria-live="polite"
       [attr.aria-label]="stap.titel | translate"
       [class.zichtbaar]="zichtbaar()"
       [class.onder]="plek()?.kant === 'onder'"
       [class.boven]="plek()?.kant === 'boven'"
       [style.top.px]="plek()?.top ?? 0"
       [style.left.px]="plek()?.left ?? 0">
    @if (plek(); as p) {
      @if (p.kant !== 'midden') {
        <span class="pijl" [style.left.px]="p.pijl - 6" aria-hidden="true"></span>
      }
    }
    <div class="ballon-titel">{{ stap.titel | translate }}</div>
    <p class="ballon-tekst">{{ stap.tekst | translate }}</p>
    <div class="voet">
      <div class="stippen" aria-hidden="true">
        @for (i of stippen(); track i) {
          <i [class.aan]="i === rondleiding.index()"></i>
        }
      </div>
      <span class="visually-hidden">
        {{ 'ONBOARDING.welkom.stap' | translate: { nr: rondleiding.index() + 1, totaal: rondleiding.aantal() } }}
      </span>
      <div class="rechts">
        <button type="button" class="knop-tekst" (click)="onOverslaan()">{{ 'ONBOARDING.tour.overslaan' | translate }}</button>
        <button #volgende type="button" class="knop-groen" (click)="onVolgende()">
          {{ (rondleiding.laatste() ? 'ONBOARDING.tour.klaar' : 'ONBOARDING.tour.volgende') | translate }}
        </button>
      </div>
    </div>
  </div>
}
